module.exports = __webpack_public_path__ + "static/media/spacey-2026-3d.a3b1b020.svg";